import { FunctionComponent, MouseEvent, memo, useMemo } from 'react';
import sprite from '../../../assets/icons/sprite.svg';
import { CircularLoader } from '../CircularLoader';

import classNames from 'classnames';
import classes from './FollowChip.module.scss';

interface FollowChipProps {
  label: string;
  followed: boolean;
  isPending: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  truncate?: boolean;
  className?: string;
}

export const FollowChip: FunctionComponent<FollowChipProps> = memo(
  ({ label, followed, isPending, onClick, truncate, className }) => {
    const icon = useMemo(() => {
      if (isPending) {
        return (
          <CircularLoader className={classes['chip__loader']} sizeRem={0.875} borderRem={0.125} />
        );
      }

      return (
        <svg className={classes['chip__icon']}>
          <use href={`${sprite}#${followed ? 'checkmark' : 'add-plus'}`} />
        </svg>
      );
    }, [followed, isPending]);

    return (
      <button
        type={'button'}
        className={classNames(classes['chip'], className, {
          [classes['chip--followed']]: followed,
        })}
        aria-pressed={followed}
        disabled={isPending}
        onClick={onClick}
      >
        {icon}
        <span
          className={classNames(classes['chip__label'], {
            [classes['chip__label--truncate']]: truncate,
          })}
        >
          {label}
        </span>
      </button>
    );
  }
);
